var utils = {
    money:180,
    year:2021,
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    },
    formDate:{
        sf: {
            'name': '(省/市)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        sx: {
            'name': '(市/县)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        xq: {
            'name': '(县/区)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        WorkName: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Cardid: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Sex:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        educity:{
            'name':'属地（市）','value':'',option:'eduadd','showSelect':true,'select':[
                '海口','三亚','琼海','儋州','洋浦','东方','五指山','万宁','文昌','屯昌','保亭','临高','定安','乐东',
                '白沙','琼中','陵水','昌江','澄迈','省外市'
            ]
        },
        NATIVEPLACE: {
            'name': '注册工作属地','value':'','placeholder':'请填写','option':'userName','showSelect':true,'select':[
                '海口','三亚','琼海','儋州','洋浦','东方','五指山','万宁','文昌','屯昌','保亭','临高','定安','乐东',
                '白沙','琼中','陵水','昌江','澄迈','省外市']
        },
        NATION:{
            'name':'民族','value':'',option:'NATION','showSelect':true,'select':
            ['汉族','蒙古族','回族','藏族','维吾尔族','彝族','壮族','布依族','朝鲜族','傣族',
            '德昂族','满族','侗族','瑶族','白族','土家族','哈尼族','景颇族', '哈萨克族','黎族',
            '傈僳族','畲族','高山族','拉祜族','水族','东乡族','纳西族','柯尔克孜族','土族','达斡尔族',
            '仫佬族','羌族','布朗族', '撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族',
            '怒族','乌孜别克族','俄罗斯族','鄂温克族','塔塔尔族','独龙族', '鄂伦春族','赫哲族','门巴族', '珞巴族',
            '基诺族','保安族','京族','佤族','裕固族','苗族'],
        },
        MEDULEVEL:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        MEDUSPEC:{
            'name':'专业','value':'',option:'education','showSelect':true,'select':['中药学','药学','相关专业'],
        },
        sort: {
            'name':'证书类型','value':'',option:'certificate','showSelect':true,'select':['执业药师','从业药师',''],
        },
        ExtentOne:{
            'name':'执业类别','value':'',option:'operation','showSelect':true,'select':['药学','中药学','药学和中药学'],
        },
        QualiCode:{
            'name':'西药证书编号','value':'',option:'operation','showSelect':false,type:'date'
        },
        zQualiCode:{
            'name':'中药证书编号','value':'',option:'operation','showSelect':false,type:'date'
        },
        ATTEYEAR: {
            'name':'西药证书考取考取年份','value':'','placeholder':'请填写，如：考试年月',option:'time','showSelect':false
        },
        zATTEYEAR: {
            'name':'中药证书考取年份','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
       
        ExtentTwo:{
            'name':'执业范围','value':'',option:'operatorScope','showSelect':true,'select':
            ['生产','批发','零售','使用','检验','其他','无'],
        },
        WorkUnit:{
            'name':'工作单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        HANDSETPHONE:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },
        MEDUSCHOOL:{
            'name':'毕业学校','value':'','placeholder':'请填写',option:'school','showSelect':false
        },
        MEDUTIME:{
            'name':'毕业时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        technicOne:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','员级','卫生技术人员','无'],
        },
        JOBLEVEL:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        WorkStat:{
            'name':'从事岗位','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        address:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        postalcode:{
            'name':'邮政编码','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        LINKPHONE:{
            'name':'单位电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        email:{
            'name':'电子邮箱','value':'','placeholder':'请填写',option:'email','showSelect':false
        },
        grjl:{
            'name':'个人简历','value':'','placeholder':'请填写',option:'email','showSelect':false,typpe:'textarea'
        },
        WORKSTATION:{
            'name':'岗位','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        zw:{
            'name':'职务','value':'','placeholder':'请填写',option:'email','showSelect':false,
        },
        QUALICODE:{
            'name':'药品经营许可证号','value':'','placeholder':'请填写',option:'email','showSelect':false,
        },
        BIRTHDAY:{
            'name':'出生年月','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        byzpic:{
            'name':'毕业证书','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zgzpic:{
            'name':'西药资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zzgzpic:{
            'name':'中药资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
      
      },
      changefocus(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        if(isAndroid){
          setTimeout(function() {
           document.activeElement.scrollIntoViewIfNeeded();
           document.activeElement.scrollIntoView();
          }, 500);       
        }
    },
    changeBlur(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if(isIOS){
          setTimeout(() => {
            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 200)
        }
    },
   IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            return false
        } else if(isEdge) {
            return false//edge
        } else if(isIE11) {
            return true; //IE11  
        }else{
            return true;//不是ie浏览器
        }
    },
      enrollStr (str) {
        let str2 = ''
        if (str === 'face') {
            str2 = '函授'
        } else if (str === 'online') {
            str2 = '网络'
        } else if (str === 'repair') {
            str2 = '补修'
        }
        return str2
      },
      clear () {
        window.localStorage.clear();
      },
      token: {
        set (token) {
              window.localStorage.setItem("token", token);
          },
          get () {
              return window.localStorage.getItem('token');
          },
        remove () {
          window.localStorage.removeItem('token')
        }
      },
      news: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("newsIndex", str);
        },
        get () {
          return window.localStorage.getItem('newsIndex');
        },
        setList (str) {
            window.localStorage.setItem("Keyword", str);
        },
        getList () {
            return   window.localStorage.getItem("Keyword");
        }
      },
      userName: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("userName", str);
        },
        get () {
          return window.localStorage.getItem('userName');
        },
      },
      courseId: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("courseNum", str);
        },
        get () {
          return window.localStorage.getItem('courseNum');
        },
      },
      enroll: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("enrollName", str);
        },
        get () {
          return window.localStorage.getItem('enrollName');
        },
      },
      info: {
        set (str) { // 获取详细的新闻
         window.localStorage.setItem("info", str);
        },
        get () {
         return window.localStorage.getItem('info');
        }, 
      },
      quwstions2020:[
      ]
    }
    export default utils
    


// WEBPACK FOOTER //
// ./src/utils/index.js